import { SetToastMessage } from 'redux/types/commonModel';
import { ToastVariant } from 'shared/utils/Constants';
import * as actionTypes from '../actionTypes';

export const setToastAction = (variant: ToastVariant, message: string): SetToastMessage => ({
    type: actionTypes.SET_TOAST_MESSAGE,
    variant,
    message,
});
